import * as React from 'react';
import { Id } from '../../utils/ids.js';
import { Bem, addClass } from '../../utils/css.js';
import '../../constants.js';
import { WordToggleOption } from './WordToggleOption.js';
import './WordToggle.scss.js';
import { WordToggleContextProvider } from './WordToggleContext.js';

const bem = Bem.create("vai-word-toggle");
class WordToggle extends React.PureComponent {
  render() {
    const { htmlId, dataTa, className, children, onChange, value, disabled, ...rest } = this.props;
    const id = Id.create(htmlId, ["word toggle"]);
    return /* @__PURE__ */ React.createElement("div", {
      id: id.toString(),
      role: "radiogroup",
      "data-ta": dataTa,
      "aria-disabled": disabled,
      "data-disabled": disabled,
      className: addClass(bem.block(), className),
      ...rest
    }, /* @__PURE__ */ React.createElement(WordToggleContextProvider, {
      value: { onChange, value, disabled }
    }, children));
  }
}
WordToggle.Option = WordToggleOption;

export { WordToggle };
